import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default function ModalBody({ className = '', children = null }) {
  return <div className={cn(styles.container, className)}>{children}</div>;
}
